import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

export default function useBDocTranslator() {
  // To manage translations
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState("es");

  // Func to change the language on demand
  const onChangeLanguaje = useCallback(() => {
    setLanguage((prevLang) => {
      const newLang = prevLang === "es" ? "en" : "es";
      i18n.changeLanguage(newLang);
      return newLang;
    });
  }, [i18n]);

  const changeDirectLanguage = useCallback(
    (lang) => {
      setLanguage(lang);
      i18n.changeLanguage(lang);
    },
    [i18n]
  );

  return {
    language,
    onChangeLanguaje,
    t,
    setLanguage,
    changeDirectLanguage,
  };
}
